// extracted by mini-css-extract-plugin
export default {"strong":"strong__IZRmS","serif":"serif__XnC9A"};